import React from "react";
import { useQuery } from "react-query";
import { FormattedMessage as T } from "react-intl";
import { CircularProgress } from "@mui/material";

import { IBaseModel } from "services/KnowfullyAdminClient";

type BaseModelQueryResult = {
  data?: IBaseModel | IBaseModel[];
};

type BaseModelFromListDisplayerProps = {
  id: string;
  cacheKey: any;
  nameKey?: string;
  fetcher: () => Promise<BaseModelQueryResult>;
};

const BaseModelNameDisplayer = ({
  id,
  cacheKey,
  fetcher,
}: BaseModelFromListDisplayerProps) => {
  const { isLoading, isError, error, data } = useQuery<BaseModelQueryResult>(
    [cacheKey, id],
    fetcher
  );

  if (isLoading) return <CircularProgress size={16} />;
  if (isError) {
    console.log(error);
    return (
      <span>
        <T id="fetchError" />
      </span>
    );
  }

  const value = Array.isArray(data!.data)
    ? data!.data!.find(({ id: dataId }) => id === dataId)
    : data!.data!;

  return <span>{value?.name ?? "?"}</span>;
};

export default BaseModelNameDisplayer;
